(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "./picker-dialog", "./picker-header", "./picker-footer", "./pick-time"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("./picker-dialog"), require("./picker-header"), require("./picker-footer"), require("./pick-time"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.pickerDialog, global.pickerHeader, global.pickerFooter, global.pickTime);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _pickerDialog, _pickerHeader, _pickerFooter, _pickTime) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _pickerDialog = _interopRequireDefault(_pickerDialog);
  _pickerHeader = _interopRequireDefault(_pickerHeader);
  _pickerFooter = _interopRequireDefault(_pickerFooter);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-picker-dialog', {
        staticClass: "dialog-modal",
        on: {
          "close": _vm.$_onClose
        }
      }, [_c('nx-picker-header', [_vm._v(_vm._s(_vm.title))]), _c('div', {
        ref: "boxContent",
        staticClass: "nx-box-content",
        class: [_vm.formatNum ? 'paddingYM' : 'paddingYMD']
      }, [_c('div', {
        staticClass: "nx-content-doc",
        class: [_vm.formatNum ? 'formatYM' : 'formatYMD']
      }, _vm._l(_vm.format, function (elem) {
        return _c('span', {
          key: elem
        }, [_vm._v(_vm._s(_vm._f("toShow")(elem)))]);
      }), 0), _vm._l(_vm.format, function (elem) {
        return _c('div', {
          key: elem,
          staticClass: "nx-time-items"
        }, [_c('ul', {
          staticClass: "nx-time-list"
        })]);
      })], 2), _c('nx-picker-footer', [_c('div', {
        on: {
          "click": _vm.$_onClose
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.leftBtn))])]), _c('div', {
        on: {
          "click": _vm.$_onConfirm
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.rightBtn))])])])], 1);
    },
    name: 'nx-picker-time',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _pickerHeader.default.name, _pickerHeader.default), (0, _defineProperty2.default)(_components, _pickerFooter.default.name, _pickerFooter.default), (0, _defineProperty2.default)(_components, _pickerDialog.default.name, _pickerDialog.default), _components),
    props: {
      title: {
        type: String,
        default: '选择日期'
      },
      leftBtn: {
        type: String,
        default: '取消'
      },
      rightBtn: {
        type: String,
        default: '确定'
      },
      minYear: {
        type: Number,
        default: 1990
      },
      maxYear: {
        type: Number,
        default: 2020
      },
      minMonth: {
        type: Number,
        default: 1
      },
      maxMonth: {
        type: Number,
        default: 12
      },
      currentYear: {
        type: Number,
        default: new Date().getFullYear()
      },
      currentMonth: {
        type: Number,
        default: new Date().getMonth() + 1
      },
      currentDate: {
        type: Number,
        default: new Date().getDate()
      },
      format: {
        type: Array,
        default: function _default() {
          return ['YYYY', 'MM'];
        }
      }
    },
    data: function data() {
      return {
        yearsList: [],
        monthsList: [],
        daysList: [],
        time: {}
      };
    },
    computed: {
      formatNum: function formatNum() {
        return this.format.length === 2;
      }
    },
    created: function created() {
      this.yearsList = (0, _pickTime.getTimes)(this.minYear, this.maxYear);
      this.monthsList = (0, _pickTime.getTimes)(this.minMonth, this.maxMonth);
      this.daysList = (0, _pickTime.getDays)(this.currentYear, this.currentMonth);
    },
    mounted: function mounted() {
      this.$_onTimePicker();
      this.$nextTick(function () {
        var node = document.querySelector('.dialog-modal');
        node.addEventListener('touchmove', function (e) {
          e.stopPropagation();
          e.preventDefault();
        }, false);
      });
    },
    filters: {
      toShow: function toShow(value) {
        var str;

        switch (value) {
          case 'YYYY':
            str = '年';
            break;

          case 'MM':
            str = '月';
            break;

          default:
            str = '日';
        }

        return str;
      }
    },
    methods: {
      $_onConfirm: function $_onConfirm() {
        this.$emit('confirm', this.time);
      },
      $_onClose: function $_onClose() {
        this.$emit('close'); // this.$_onTimePicker()
      },
      $_onTimePicker: function $_onTimePicker() {
        var options = {
          yearsArr: this.yearsList,
          monthsArr: this.monthsList,
          datesArr: this.daysList,
          currentYear: this.currentYear,
          currentMonth: this.currentMonth,
          currentDate: this.currentDate
        };
        this.time = new _pickTime.datePicker(options, this.format, this.$refs.boxContent);
      }
    }
  };
  _exports.default = _default2;
});